import { type DancerRole } from '../app/models/DancerRole';

import { type ParticipantFilters, ParticipantModel } from './Participant';
import { type UserDto, type UserFilters } from './User';

export interface JudgeFilters extends UserFilters, ParticipantFilters {
  dancerRole?: DancerRole;
}

export interface JudgeDto extends UserDto {
  dancerRole?: DancerRole | null;
  contestId: string | null;
}

export type JudgeExtendedDto = JudgeDto;

export class JudgeModel extends ParticipantModel implements Omit<JudgeDto, 'status'> {}
